module.exports = __webpack_public_path__ + "static/media/btn.4e928fb3.svg";